var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-breadcrumbs"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("title.main")))]),_vm._v(" > "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }